import { getStore } from '@/utils/dva'

export const getUserCoId = () => {
    const state = getStore()?.getState() || {}
    const currentUser = state?.user?.currentUser || {}

    return currentUser?.coId
}

export default ({ itemCoId }) => {
    if (itemCoId) {
        const userCoId = getUserCoId()

        return userCoId === itemCoId
    }

    return true
}
